<template>
  <v-dialog v-model="dialogVisible" 
    persistent
    max-width="360px" 
  >
    <template #activator="{ on, attrs }">
      <v-btn
        fab x-small rounded dark 
        class="ml-2" color="grey darken-1"
        v-bind="attrs" v-on="on"
      >
        <v-icon dark>mdi-tune</v-icon>
      </v-btn>
    </template>

    <v-form @submit.prevent="submitClick" autocomplete="off">
      <v-card>
        <v-card-title class="py-2">
          Filter Users by
        </v-card-title>
        <v-divider />
        <v-card-text class="mt-2 pb-0">
          <v-select
            outlined dense
            v-model="inactive"
            :items="activeOptions"
            item-text="label"
            item-value="filter"
            label="Show Me"
          />
        </v-card-text>

        <v-divider />

        <v-card-actions class="justify-center py-3">
          <v-btn @click="dialogVisible = false">Cancel</v-btn>
          <v-btn class="ml-3" color="primary" type="submit">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'UserFilterDialog',

  data() {
    return {
      dialogVisible: false,

      inactive: 1,

      activeOptions: [
        { label: 'Active Users', filter: null },
        { label: 'All Users', filter: 1 },
      ]
    }
  },

  computed: {
    ...mapGetters('filters', ['usersFilters']),
  },

  methods: {
    ...mapActions('filters', ['loadUsersFilters', 'updateUsersFilters']),

    submitClick() {
      this.updateUsersFilters( { 
        inactive: this.inactive,
      } )
      this.dialogVisible = false
    },

    onShow() {
      this.inactive = this.usersFilters.inactive
    },
  },

  watch: {
    dialogVisible(visible) {
      if (visible) {
        this.onShow()
      }
    },
  },

  created() {
    this.loadUsersFilters()
  }
}
</script>